module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "padding-top": "150px"
    }
  }, [_vm._v("This is a story of new, which surprisingly involves you. Whoever you are, wherever you are, at whatever stage in life you are, I do not think you believe we cease to exist after we meet our tragic demise. Not only that you do not believe it but you feel it within you; that feeling—that death is just not the end. This book will introduce a probable scenario to your life, one that might slightly change your perceptions about ‘life’ after death.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Similar to dreaming, most certainly, we are not susceptible to feel the passing of time when we face death. If we were to wake up from a year’s long sleep that would feel like the blink of an eye. What if we were to wake up from our ‘forever’ sleep into a far and distant future? What if our predecessors were to wake us up? Could we perhaps reach for such lengths? It might seem impossible but is it improbable?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258a58b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 69
// module chunks = 0